import table from '../../authorization/roles.json' with { type: 'json' };

/**
 * The role to capability policy of beyond-cdn-management/1, read from `authorization/roles.json`.
 *
 * Roles belong to the shared Beyond authority; this table only states what each role may do in CDN.
 */
export class Roles {
	/**
	 * Role names, identical to the Workspace administration contract
	 *
	 * @returns {string[]}
	 */
	static get names() {
		return Object.keys(table.roles);
	}

	/**
	 * @param {string} role
	 * @returns {string[]} The CDN capabilities of the role, empty for an unknown role
	 */
	static capabilities(role) {
		return [...(table.roles[role] ?? [])];
	}

	/**
	 * @param {string | undefined} role The role of the caller in the organization that owns the resource
	 * @param {string} capability A CDN capability
	 */
	static allows(role, capability) {
		return Roles.capabilities(role).includes(capability);
	}

	/**
	 * Capabilities reserved to platform operators. No organization role grants them.
	 *
	 * @returns {string[]}
	 */
	static get platform() {
		return Object.keys(table.platform.capabilities);
	}

	/**
	 * Capabilities that also require the caller to be admitted to CDN management and preparation. A member
	 * whose role holds one but who is not admitted is refused with ADMISSION_REQUIRED.
	 *
	 * @returns {string[]}
	 */
	static get admission() {
		return [...(table.admission?.capabilities ?? [])];
	}

	/**
	 * @param {string} capability A CDN capability
	 * @returns {boolean} Whether exercising it requires admission
	 */
	static admits(capability) {
		return Roles.admission.includes(capability);
	}
}
